import LatoRegular from '../fonts/Lato-Regular.ttf'
import PoppinsBold from '../fonts/Poppins-Bold.ttf'

const latoLight = {
  fontFamily: 'LatoRegular',
  src: `local('LatoRegular'),url(${LatoRegular}) format('woff2')`,
}

const poppinsBold = {
  fontFamily: 'PoppinsBold',
  src: `local('PoppinsBold'),url(${PoppinsBold}) format('woff2')`,
}

export const TELECABLE_THEME = {
  palette: {
    primary: { main: '#0056bb', light: '#E3EEFC', black: '#000000' },
    secondary: {
      contrastText: '#fff',
      main: '#0056bb',
    },
    disabled: {
      alternativeDisableColor: '#0056bb',
      text: '#BBBDBD',
      background: '#E1E3E3',
    },
    secondaryTitle: {
      main: '#c3c3c3',
    },
    icon: {
      main: '#0056bb',
    },
    menu: { main: '#0056bb' },
    header: {
      background: '#0056bb',
      text: '#fff',
    },
    headerLinks: {
      background: '#ffffff',
      text: '#000000',
      hover: '#0056bb',
    },
    footer: {
      main: '#000',
      background: '#f2f2f2',
      icons: '#000',
      hover: '#0056bb',
    },
    button: {
      color: '#fff',
      backgroundColor: '#0056bb',
      hoverColor: '#0056bb',
      hoverBackgroundColor: '#fff',
      hoverBorderColor: '#0056bb',
    },
    table: {
      headerText: '#9b9b9b',
    },
    success: { main: '#00D41F' },
    warning: { main: '#EEC303' },
    error: { main: '#FF0000' },
    info: { main: '#008DFF' },
    breadcrumb: {
      color: '#0056bb',
      backgroundColor: '#fff',
    },
    user: {
      icon: '#008DFF',
      background: '#ffffff',
    },
    langBar: {
      backgroundColor: '#ffffff',
      color: '#000000',
    },
    switchColor: {
      color300: '#0056bb',
      color500: '#3377c8',
    },
  },
  typography: {
    h1: {
      fontFamily: 'poppinsBold',
      fontSize: '1.75rem',
    },
    h2: {
      fontFamily: 'poppinsBold',
      fontSize: '1.5rem',
    },
    h3: {
      fontFamily: 'latoRegular',
      fontSize: '1.2rem',
    },
    h4: {
      fontFamily: 'poppinsBold',
      fontSize: '1.2rem',
    },
    h5: {
      fontFamily: 'poppinsBold',
      fontSize: '1.1rem',
    },
    h6: {
      fontFamily: 'latoRegular',
      fontSize: '1rem',
    },
    body1: {
      fontFamily: 'latoRegular',
      fontSize: '1rem',
    },
    body2: {
      fontFamily: 'latoRegular',
      fontSize: '0.9rem',
    },
    subtitle1: {
      fontFamily: 'latoRegular',
      fontSize: '0.7rem',
    },
    subtitle2: {
      fontFamily: 'latoRegular',
      fontSize: '0.65rem',
      fontWeight: 600,
    },
  },
  borderBottom: {
    borderBottom: '4px solid #0056bb',
  },
  borderTopMainMenu: {
    borderTop: '0px solid #0056bb',
  },
  footerShadow: {
    boxShadow: 'none',
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [latoLight, poppinsBold],
        body: {
          minWidth: '289px',
          width: '100%',
          fontSize: '0.875rem',
          lineHeight: '1.43rem',
          backgroundColor: 'white',
        },
        main: {
          width: '100%',
        },
        ' .grecaptcha-badge': {
          display: 'none',
        },
        '.MuiIconButton-root': {
          color: '#0056bb !important',
          '&.Mui-disabled': {
            color: 'rgba(0, 0, 0, 0.26) !important',
          },
        },
        '.MuiAppBar-root': {
          display: 'block',
        },
        '.MuiPaper-rounded': {
          borderRadius: '10px !important',
        },
        '.MuiPickersDay-day.MuiPickersDay-daySelected > .MuiIconButton-label > .MuiTypography-root': {
          color: '#fff !important',
        },
        '.MuiButton-root': {
          backgroundColor: '#0056BB',
          margin: '5px 5px 5px 0px',
          color: 'white',
          '&:disabled': {
            backgroundColor: 'rgba(0,0,0,0.12)',
          },
          '&:hover': {
            color: '#0056BB !important',
          },
        },
        '.MuiButton-textSizeSmall': {
          height: '22px',
          borderRadius: '0px',
        },
        '.MuiCardHeader-content > p': {
          marginTop: '5px',
        },
        '.MuiCardHeader-avatar': {
          marginRight: '3px !important',
        },
        '.textErrorsColors': {
          color: 'red',
        },
        '.MuiContainer-root': {
          marginLeft: '25px',
          marginTop: '25px',
          marginBottom: '6rem',
        },
        '.MuiDataGrid-footerContainer': {
          position: 'relative',
          top: '10px',
        },
        '.messagesErrorInvoiceContainer': {
          paddingTop: '5px',
        },
        '.MuiDataGrid-root': {
          border: 'none !important',
        },
        '.MuiCardContent-root:last-child': {
          padding: '16px !important',
        },
        '.MuiDataGrid-root .MuiDataGrid-row.Mui-selected:hover': {
          'background-color': 'rgba(73, 73, 73, 0.12) !important',
        },
        '.MuiDataGrid-root .MuiDataGrid-row.Mui-selected': {
          'background-color': 'rgba(99, 99, 99, 0.08) !important',
        },
        '.MuiDataGrid-root .MuiDataGrid-columnSeparator': {
          display: 'none !important',
        },
        '.MuiDataGrid-root .MuiDataGrid-columnsContainer': {
          'background-color': 'trasparent !important',
        },
        '.MuiDataGrid-root .MuiDataGrid-columnHeaderTitleContainer': {
          'padding-left': '0rem !important',
          'padding-right': '0rem !important',
        },
        '.MuiDataGrid-root .MuiDataGrid-columnHeaderCheckbox': {
          'padding-right': '0rem !important',
        },
        '.MuiPaper-elevation1': {
          'box-shadow': '0px 0px 13px 3px rgb(0 0 0 / 10%) !important',
        },
        '.buttons': {
          'margin-top': '0px !important',
          'flex-direction': 'row !important',
          'justify-content': 'flex-start !important',
        },
        '.MuiMenu-paper': {
          zIndex: 9999,
        },
        '.MuiDialogContent-root': {
          overflowY: 'visible !important',
          margin: '1rem',
        },
        '*::-webkit-scrollbar': {
          width: 5,
        },
        '*::-webkit-scrollbar-track': {
          background: 'transparent',
        },
        '*::-webkit-scrollbar-thumb': {
          background: '#0056BB',
        },
      },
    },
  },
}
